// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"dee4105d","75":"5c1ce90d","116":"01888b34"}[chunkId] + ".chunk.js";
};